export default __webpack_public_path__ + "static/media/princest.ae702be9.jpeg";